export default __webpack_public_path__ + "static/media/about1.9425a79c.jpeg";